import { render, staticRenderFns } from "./MaterialUpdate.vue?vue&type=template&id=5ca45123"
import script from "./MaterialUpdate.vue?vue&type=script&lang=js"
export * from "./MaterialUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports